<ng-container [formGroup]="uploadForm">
	<input
		*ngIf="isModule"
		[placeholder]="titlePlaceHolder | translate"
		formControlName="title"
		pInputText
		type="text"
	/>
	<textarea
		*ngIf="isModule"
		[placeholder]="'presentation.app.chat.upload.module.placeHolder' | translate"
		formControlName="description"
		pInputTextarea
		rows="5"
	></textarea>
	<div
		[class.pointer-events-none]="isUploading$ | async"
		(click)="file.click()"
		class="
			flex
			cursor-pointer
			border border-solid
			items-center
			flex-col
			justify-center
			break-all
			p-border-color-component-background p-color-text-secondary p-3
		"
	>
		<i
			*ngIf="!(isUploading$ | async)"
			class="fas fa-file-upload text-3xl leading-none"
		></i>
		<span *ngIf="!(isUploading$ | async)" class="mt-3">
			{{ fileName$ | async }}
		</span>
		<p-progressSpinner
			*ngIf="isUploading$ | async"
			[style]="{ width: '50px', height: '50px' }"
		></p-progressSpinner>
	</div>
	<textarea
		[placeholder]="'presentation.app.chat.upload.message.placeHolder' | translate"
		formControlName="message"
		pInputTextarea
		rows="2"
	></textarea>
	<button
		*ngIf="!(isCreating$ | async)"
		[disabled]="!(isFormValid$ | async)"
		[label]="'presentation.app.chat.upload.submit.label' | translate"
		(click)="onSubmitClick()"
		pButton
	></button>
	<p-progressSpinner
		*ngIf="isCreating$ | async"
		[style]="{ width: '25px', height: '25px' }"
		class="self-center"
	></p-progressSpinner>
	<input
		#file
		(change)="onFileChange($event, file)"
		class="hidden"
		accept="*/*"
		type="file"
	/>
</ng-container>
